import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClockThree = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 4.66667V8H10.5M14.5 8C14.5 11.3137 11.8137 14 8.5 14C5.18629 14 2.5 11.3137 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClockThree;
